import ChatContext from "@/shared/models/ChatContext";
import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ChatShort } from "../../../shared/models/Chat";
import {
  EventName,
  EventParameter,
  EventTitle,
  sendEvent,
} from "../../../shared/utils/UsageAnalytics";

export const useCreateChat = () => {
  const { call, isLoading } = useApiPrivateRequest<ChatShort>((response) => {
    return new ChatShort(response);
  });

  const createChat = async (input: string, context: ChatContext) => {
    const data = context.extractChatCreateData();
    const body = {
      input: input,
      companyIds: data.companyIds,
      filingIds: data.filingIds,
      transcriptIds: data.transcriptIds,
      userDocumentIds: data.userDocumentIds,
      useInternet: data.includeWeb,
      llmName: data.selectedLlmName,
    };

    const response = await call("/chats", "POST", undefined, body);

    if (response) {
      sendEvent(EventName.ChatCreated, {
        [EventParameter.Label]: EventTitle.ChatModeCompanyDocsV2,
        [EventParameter.CompanyCount]: data.companyIds.length.toString(),
        [EventParameter.DocumentCount]: data.filingIds.length.toString(),
        [EventParameter.TranscriptCount]: data.transcriptIds.length.toString(),
        [EventParameter.ContentCount]: data.userDocumentIds.length.toString(),
        [EventParameter.UseInternet]: data.includeWeb.toString(),
        [EventParameter.MlModel]: data.selectedLlmName,
      });
    }

    return response;
  };

  return { createChat, isLoading };
};
